import React from 'react'
import Cards from '../cards'

const Homelessness = (props) => {
   

    return (

        <div className='bg-white-homelessness homelessness' key={'homelessCards'}>
            <div className='container px-0 px-md-3'>
                <h2 className='title red'>{props?.title}</h2>
                <p className='text-normal lightGrey inter-font mb-2'>{props?.description}</p>
                <ul className="card-container d-flex justify-content-between flex-wrap justify-content-md-start">
                    {Array.isArray(props.homelessCards) && props.homelessCards.length > 0 ? (
                        <>
                            {props.homelessCards.map((item, index) => {
                                // Prefer a stable id from the data when available
                                const key = item.externalSiteId || item.externalSiteLink || `homeless-card-${index}`;
                                return (
                                    <Cards
                                        key={key}
                                        type='site'
                                        title={item.externalSiteTitle}
                                        link={item.externalSiteLink}
                                    />
                                );
                            })}
                        </>
                    ) : null}
                   
                </ul>
            </div>
        </div>
    )
}

export default Homelessness
